import { FC, useContext } from 'react';

import { AddBarcodeIcon, H3, Input } from '@smartshell/ui-kit';
import cn from 'classnames';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from '../Tariff.module.scss';
import { ITariffEanSectionProps } from './interfaces';

export const TariffEanSection: FC<ITariffEanSectionProps> = ({ control }) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s['form-block']}>
      <H3 className={s.header}>{t('ean')}</H3>
      <div className={cn(s.fields, s.ean)}>
        <Controller
          control={control}
          render={({
            field: { onChange, ...field },
            fieldState: { error },
          }) => (
            <Input
              {...field}
              title={t('ean')}
              pattern="\d*"
              onChange={(value, event) => {
                if (event.target.validity.valid) {
                  onChange(value);
                }
              }}
              errorWrapperClassName={s.fullWidth}
              rightContent={<AddBarcodeIcon />}
              error={error?.message}
              bordered
            />
          )}
          name="ean"
          rules={{
            pattern: {
              value: /^\d{8,16}$/,
              message: t('good.manager.eans.error.length'),
            },
          }}
        />
        <span className={s.description}>{t('ean.help')}</span>
      </div>
    </div>
  );
};
